// setLiveStreamChatroom.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
const selectPath = ['liveStream', 'chatroom'];

/**
 * Set live stream chatroom scrolling
 * @kind action
 * @param {bool} {isScrolling} - LiveStream Chatroom is scrolling or not
 * @return {Promise} Action promise.
 */
const setLiveStreamChatroom =
  ({ isScrolling }) =>
  async dispatch => {
    let data = {
      isScrolling,
    };
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: { selectPath, data },
    });
  };

export default setLiveStreamChatroom;
